"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tab = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactShapes = require("@mulesoft/exchange-react-shapes");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "container": "container_FrVhDK",
  "tabs-title": "tabs-title_2QyvsW",
  "tabsTitle": "tabs-title_2QyvsW",
  "tabs": "tabs_1qj5IT",
  "is-collapsed": "is-collapsed_1FVqZ3",
  "isCollapsed": "is-collapsed_1FVqZ3",
  "toggle": "toggle_3-sJ-e",
  "is-expanded": "is-expanded_3OA1SA",
  "isExpanded": "is-expanded_3OA1SA",
  "tab": "tab_3TVKpi",
  "selected": "selected_1jb2hS",
  "toggle-content": "toggle-content_AEnzfS",
  "toggleContent": "toggle-content_AEnzfS",
  "content": "content_3Vbr1c",
  "hidden": "hidden_3F1I8l"
}; 
require('../CollapsibleTabs.css');
var handleKeyDown = function handleKeyDown(_ref) {
  var event = _ref.event,
    onSelect = _ref.onSelect,
    onMoveLeft = _ref.onMoveLeft,
    onMoveRight = _ref.onMoveRight;
  if (event.key === 'Enter') {
    onSelect(event);
  } else if (event.key === 'ArrowLeft') {
    onMoveLeft();
  } else if (event.key === 'ArrowRight') {
    onMoveRight();
  }
};
var Tab = exports.Tab = /*#__PURE__*/function (_React$Component) {
  function Tab() {
    (0, _classCallCheck2.default)(this, Tab);
    return _callSuper(this, Tab, arguments);
  }
  (0, _inherits2.default)(Tab, _React$Component);
  return (0, _createClass2.default)(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        index = _this$props.index,
        isSelected = _this$props.isSelected,
        isTabbable = _this$props.isTabbable,
        parentId = _this$props.parentId,
        innerRef = _this$props.innerRef,
        onSelect = _this$props.onSelect,
        onMoveLeft = _this$props.onMoveLeft,
        onMoveRight = _this$props.onMoveRight;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "collapsible-tab",
        className: (0, _classnames.default)(styles.tab, (0, _defineProperty2.default)({}, styles.selected, isSelected)),
        ref: innerRef,
        role: "tab",
        id: "".concat(parentId, "-").concat(index, "-tab"),
        "aria-controls": "".concat(parentId, "-").concat(index, "-panel"),
        "aria-selected": isSelected ? 'true' : 'false',
        onClick: onSelect,
        onKeyDown: function onKeyDown(event) {
          return handleKeyDown({
            event: event,
            onSelect: onSelect,
            onMoveLeft: onMoveLeft,
            onMoveRight: onMoveRight
          });
        },
        tabIndex: isTabbable ? '0' : '-1'
      }, title);
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(Tab, "propTypes", {
  index: _propTypes.default.number,
  title: _propTypes.default.string.isRequired,
  isSelected: _propTypes.default.bool,
  isTabbable: _propTypes.default.bool,
  parentId: _propTypes.default.string,
  innerRef: _exchangeReactShapes.RefType,
  onSelect: _propTypes.default.func,
  onMoveLeft: _propTypes.default.func,
  onMoveRight: _propTypes.default.func
});
(0, _defineProperty2.default)(Tab, "defaultProps", {
  isSelected: false,
  isTabbable: false,
  onSelect: function onSelect() {},
  onMoveLeft: function onMoveLeft() {},
  onMoveRight: function onMoveRight() {}
});
var TabWithRef = function TabWithRef(props, ref) {
  return /*#__PURE__*/_react.default.createElement(Tab, (0, _extends2.default)({}, props, {
    innerRef: ref
  }));
};
var TabWrapper = /*#__PURE__*/_react.default.forwardRef(TabWithRef);
TabWrapper.get = function () {
  return TabWithRef;
};
var _default = exports.default = TabWrapper;
//# sourceMappingURL=Tab.js.map